import styled from "styled-components";

export const Value = styled.span`
    font-size: 1.25rem;
    margin-left: 1rem;

    @media (min-width: 500px) {
        font-size: 1.5rem;
    }
`;

export const Highlight = styled.li`
    color: ${props => props.theme.primary};
    display: flex;
    align-items: center;
    font-size: 1.25rem;

    @media (min-width: 500px) {
        font-size: 1.5rem;
    }
`;

export const Detail = styled.li`
    font-size: 1rem;
`;
